(function() {
'use strict';

const TR = angular.module('TR');
TR.directive('filterCriterion', function() {
    return {
        restrict: 'E',
        replace: true,
        transclude: true,
        scope: {
            close: '&',
            show: '='
        },
        templateUrl: 'partials/home/directivetemplate?type=FilterCriterion'
    };
});
})();
